"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkBrand = exports.isSocialBrandLink = exports.getEmbedUrl = exports.allowEmbedList = exports.extractVideoId = void 0;
function extractVideoId(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
}
exports.extractVideoId = extractVideoId;
exports.allowEmbedList = ['vimeo', 'youtube', 'youtu.be', 'soundcloud'];
const getEmbedUrl = (url, embed) => {
    if (!embed)
        return;
    const urls = {
        vimeo: `https://player.vimeo.com/video/${url.split('/').pop()}`,
        youtube: `https://www.youtube.com/embed/${url.split('=').pop()}`,
        'youtu.be': `https://www.youtube.com/embed/${url.split('/').pop()}`,
        soundcloud: `https://w.soundcloud.com/player/
      ?url=${url}&amp;auto_play=false&amp;hide_related=true&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true`,
    };
    return urls[embed];
};
exports.getEmbedUrl = getEmbedUrl;
const linkPrefix = '^(https?:\/\/)?([a-z0-9-]+\.)?';
const newSocialLinkRegExp = (brandDomain) => {
    return new RegExp(linkPrefix + brandDomain);
};
const socialLinksRegExp = {
    facebook: [
        newSocialLinkRegExp('facebook.com'),
        newSocialLinkRegExp('fb.me'),
        newSocialLinkRegExp('fb.com'),
        newSocialLinkRegExp('facebook.me')
    ],
    twitter: [
        newSocialLinkRegExp('twitter.com')
    ],
    medium: [
        newSocialLinkRegExp('medium.com')
    ],
    linkedIn: [
        newSocialLinkRegExp('linkedin.com'),
        newSocialLinkRegExp('linked.in')
    ],
    gitHub: [
        newSocialLinkRegExp('github.com')
    ],
    instagram: [
        newSocialLinkRegExp('instagram.com'),
        newSocialLinkRegExp('instagr.am')
    ],
    youTube: [
        newSocialLinkRegExp('youtube.com'),
        newSocialLinkRegExp('youtu.be')
    ],
    telegram: [
        newSocialLinkRegExp('t.me'),
        newSocialLinkRegExp('telegram.me')
    ],
    reddit: [
        newSocialLinkRegExp('reddit.com'),
    ]
};
const isSocialBrandLink = (brand, link) => {
    if (!link) {
        return false;
    }
    link = link.trim().toLowerCase();
    return !!socialLinksRegExp[brand].find(r => r.test(link));
};
exports.isSocialBrandLink = isSocialBrandLink;
const getLinkBrand = (link) => {
    for (const key in socialLinksRegExp) {
        const brand = key;
        if ((0, exports.isSocialBrandLink)(brand, link)) {
            return brand;
        }
    }
    return 'website';
};
exports.getLinkBrand = getLinkBrand;
